import React from "react"
import "./CancelPRSUpload.scss"

// Components
import { PrimeButton } from "components-design-system"

const CancelPRSUpload = ({ setOpenModal, onCancelUpload }) => {
  return (
    <div>
      <div className="cancel-upload-action-container">
        <PrimeButton onClick={() => setOpenModal(false)}>Back</PrimeButton>
        <PrimeButton
          onClick={onCancelUpload}
          type="primary"
          danger
        >
          Cancel Upload
        </PrimeButton>
      </div>
    </div>
  )
}

export default CancelPRSUpload
